import { createFileRoute } from "@tanstack/react-router";
import { comingSoonPage } from "@/components/ComingSoon";
import { requireAuth } from "@/lib/auth-guard";

/**
 * Sharing — mirrors iOS SharingScreen ("Family links & friend
 * circles"). Phase B wires: GET /api/v1/users/me/sharing-policies ·
 * PUT /api/v1/users/me/sharing-policies/{link_id} (debounced) ·
 * friend-circle policy via PATCH /api/v2/friend-circles/{id}.
 * Buckets verbatim from iOS: "Share all" / "Pick per memory" / "Off"
 * (+ "Mirrors guardian" for minors). Your policy governs your posts
 * only.
 */
export const Route = createFileRoute("/sharing")({
  loader: ({ context }) => requireAuth(context.queryClient),
  component: comingSoonPage(
    "Sharing",
    "Family links & friend circles — choose how your memories flow on each link: share all, pick per memory, or off. We're building this surface now.",
  ),
});
